import React from "react";
import PropTypes from "prop-types";

import RecurlyForm from "components/RecurlyForm";

const Recurly = (props) => {
  const { error, onSubscriptionChange, onSubscribe } = props;

  const handleSubmit = (values) => {
    const { firstName, lastName, postalCode, token, lastFour, brand } = values;

    const subscription = {
      payment: { firstName, lastName, postalCode, recurlyToken: token.id, lastFour, brand },
      paymentProvider: { name: "recurly" },
    };

    onSubscriptionChange(subscription);
    onSubscribe();
  };

  return <RecurlyForm error={error} onSubmit={handleSubmit} isUpdate />;
};

Recurly.propTypes = {
  error: PropTypes.string,
  onSubscribe: PropTypes.func.isRequired,
  onSubscriptionChange: PropTypes.func.isRequired,
};

export default Recurly;
